"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButton = void 0;
var react_1 = __importStar(require("react"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var Button_1 = require("../Button");
var ToggleButtonProvider_1 = require("../ToggleButtonProvider");
var css_1 = require("@emotion/css");
var activeStyles = function (selectedTheme, isFillTransparent) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  /* stylelint-disable-next-line */\n  outline: 1px solid ", ";\n\n  &:focus:enabled {\n    /* stylelint-disable-next-line */\n    background-color: ", ";\n    color: ", ";\n  }\n\n  svg {\n    ", "\n  }\n\n  &:focus:enabled svg {\n    ", "\n  }\n\n  &:hover:enabled {\n    /* stylelint-disable-next-line */\n    background-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  /* stylelint-disable-next-line */\n  outline: 1px solid ", ";\n\n  &:focus:enabled {\n    /* stylelint-disable-next-line */\n    background-color: ", ";\n    color: ", ";\n  }\n\n  svg {\n    ", "\n  }\n\n  &:focus:enabled svg {\n    ", "\n  }\n\n  &:hover:enabled {\n    /* stylelint-disable-next-line */\n    background-color: ", ";\n  }\n"])), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral70, dark: design_system_foundations_1.darkTheme.color.blueGray50 }), design_system_foundations_1.theme.color.white, (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
    light: design_system_foundations_1.theme.color.neutral100,
    dark: design_system_foundations_1.darkTheme.color.blueGray50,
}), (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
    light: design_system_foundations_1.theme.color.neutral70,
    dark: design_system_foundations_1.darkTheme.color.blueGray50,
}), design_system_foundations_1.theme.color.white, isFillTransparent
    ? "\n      stroke: ".concat(design_system_foundations_1.theme.color.white, ";\n    ")
    : "\n      fill: ".concat(design_system_foundations_1.theme.color.white, ";\n    "), isFillTransparent
    ? "\n      stroke: ".concat(design_system_foundations_1.theme.color.white, ";\n    ")
    : "\n      fill: ".concat(design_system_foundations_1.theme.color.white, ";\n    "), (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
    light: design_system_foundations_1.theme.color.neutral80,
    dark: design_system_foundations_1.darkTheme.color.blueGray50,
})); };
var inactiveStyles = function (selectedTheme, isFillTransparent) { return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover:enabled {\n    /* stylelint-disable-next-line */\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:hover:enabled svg {\n    ", "\n  }\n"], ["\n  &:hover:enabled {\n    /* stylelint-disable-next-line */\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:hover:enabled svg {\n    ", "\n  }\n"])), (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
    light: design_system_foundations_1.theme.color.neutral50,
    dark: design_system_foundations_1.darkTheme.color.blueGray100,
}), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral100, dark: design_system_foundations_1.theme.color.neutral10 }), isFillTransparent
    ? "\n      stroke: ".concat((0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral100, dark: design_system_foundations_1.theme.color.neutral10 }), ";\n    ")
    : "\n      fill: ".concat((0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral100, dark: design_system_foundations_1.theme.color.neutral10 }), ";\n    ")); };
function ToggleButtonInner(props, ref) {
    var children = props.children, value = props.value, userClassName = props.className, testId = props.testId, rest = __rest(props, ["children", "value", "className", "testId"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var context = (0, react_1.useContext)(ToggleButtonProvider_1.ToggleButtonContext);
    var _a = (0, react_1.useState)(false), isFillTransparent = _a[0], setIsFillTransparent = _a[1];
    var ButtonIcon = props.Icon;
    (0, react_1.useEffect)(function () {
        if (ButtonIcon) {
            var isOutlineIcon = ButtonIcon.displayName ? /outline([12])?$/i.test(ButtonIcon.displayName) : false;
            setIsFillTransparent(isOutlineIcon);
        }
    }, [ButtonIcon]);
    if (!context) {
        throw new Error('ToggleButton must be rendered as a child of ToggleButtonGroup');
    }
    var contextValue = context.value, onChange = context.onChange;
    var isSelected = contextValue === value;
    var className = (0, css_1.cx)(isSelected ? activeStyles(selectedTheme, isFillTransparent) : inactiveStyles(selectedTheme, isFillTransparent), userClassName, 'ds-toggle-button');
    return (react_1.default.createElement(Button_1.Button, __assign({ ref: ref }, rest, { variant: "secondary", onClick: function () { return onChange(value); }, className: className, "aria-pressed": isSelected, "data-testid": testId }), children));
}
ToggleButtonInner.displayName = 'ToggleButton';
exports.ToggleButton = (0, react_1.forwardRef)(ToggleButtonInner);
var templateObject_1, templateObject_2;
